// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1f-tI","type":"styles_type__3Sjpu","choices":"styles_choices__3zDp3"};